var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditProfile = function SvgEditProfile(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8006 4.89833L15.6006 5.29833L18.5006 6.69833L18.7006 6.29833C19.1006 5.49833 18.8006 4.49833 17.9006 4.09833C17.0006 3.69833 16.2006 4.09833 15.8006 4.89833Z",
    fill: "url(#edit_profile_paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 17.0984L10.2002 16.2984L15.1002 6.39844L16.5002 7.09844L11.7002 17.0984Z",
    fill: "url(#edit_profile_paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1002 17.7977L11.7002 17.0977L16.5002 7.09766L18.0002 7.79766L13.1002 17.7977Z",
    fill: "url(#edit_profile_paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6006 6.69688L15.6006 5.29688L15.1006 6.39688L16.5006 7.09687L18.0006 7.79688L18.6006 6.69688Z",
    fill: "#444447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 17.0969L10.2002 16.2969V18.1969L11.7002 18.8969L13.1002 17.7969L11.7002 17.0969Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7002 18.8992L10.2002 18.1992V19.9992L11.7002 18.8992Z",
    fill: "url(#edit_profile_paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 8.10156H4.5C4.2 8.10156 4 7.90156 4 7.60156C4 7.30156 4.2 7.10156 4.5 7.10156H10.4C10.7 7.10156 10.9 7.30156 10.9 7.60156C10.9 7.90156 10.7 8.10156 10.4 8.10156Z",
    fill: "url(#edit_profile_paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 11.1016H4.5C4.2 11.1016 4 10.9016 4 10.6016C4 10.3016 4.2 10.1016 4.5 10.1016H10.4C10.7 10.1016 10.9 10.3016 10.9 10.6016C10.9 10.9016 10.7 11.1016 10.4 11.1016Z",
    fill: "url(#edit_profile_paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8 13.6992H4.5C4.2 13.6992 4 13.4992 4 13.1992C4 12.8992 4.2 12.6992 4.5 12.6992H7.8C8.1 12.6992 8.3 12.8992 8.3 13.1992C8.3 13.4992 8.1 13.6992 7.8 13.6992Z",
    fill: "url(#edit_profile_paint6_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: -2,
    y: -1,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_profile_paint0_linear",
    x1: 18.6485,
    y1: 2.82932,
    x2: 16.6716,
    y2: 6.85706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2508,
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_profile_paint1_linear",
    x1: 12.3879,
    y1: 6.23398,
    x2: 15.5975,
    y2: 24.1165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_profile_paint2_linear",
    x1: 21.7907,
    y1: 5.70118,
    x2: 6.17285,
    y2: 20.8657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_profile_paint3_linear",
    x1: 11.3936,
    y1: 17.4933,
    x2: 10.6803,
    y2: 19.1568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_profile_paint4_linear",
    x1: 2.5297,
    y1: 7.70216,
    x2: 23.0758,
    y2: 7.17086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_profile_paint5_linear",
    x1: 2.6075,
    y1: 10.7086,
    x2: 23.1536,
    y2: 10.1772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edit_profile_paint6_linear",
    x1: 2.6744,
    y1: 13.2922,
    x2: 23.2205,
    y2: 12.7608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#327BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EditProfile.66b1f693.svg";
export { ForwardRef as ReactComponent };